import Hotjar from '@hotjar/browser';
import mixpanel from 'mixpanel-browser';
import * as Sentry from '@sentry/gatsby';
const siteId = 3719048;
const hotjarVersion = 6;

export const onClientEntry = () => {
    Sentry.init({
        allowUrls: [/gethealthspan\.com/, /app\.gethealthspan\.com/],
        dsn: 'https://bd58775bd8820ea4b6804dab99556037@o4504968426029056.ingest.sentry.io/4506021749653504',

        // integrations: [Sentry.replayIntegration()],
        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.5,
    });

    if (process.env.NODE_ENV === 'production') {
        mixpanel.init('0f04a2813703e28e050bd2298f9f413b');
        Hotjar.init(siteId, hotjarVersion);
    } else {
        // eslint-disable-next-line
        console.log('Mixpanel and Hotjar are disabled for development');
    }
};

export const onRouteUpdate = ({ location, prevLocation }) => {
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line
        console.log(`mixpanel.track('PageView', {
            path: ${location?.pathname},
            referrer: ${prevLocation ? prevLocation?.pathname : null},
        });`);
    } else {
        // hash or query changed
        if (location?.pathname === prevLocation?.pathname) {
            return;
        }

        mixpanel.track('PageView', {
            path: location?.pathname,
            referrer: prevLocation ? prevLocation?.pathname : null,
        });
    }
};
